
import { useEffect } from "react";
import ProfilePhotoCarousel from "./ProfilePhotoCarousel";
import ProfileDetails from "./ProfileDetails";
import ProfileActionButtons from "./ProfileActionButtons";
import { usePhotoCarousel } from "@/hooks/usePhotoCarousel";
import { useProfileActions } from "@/hooks/useProfileActions";
import { useProfileViews } from "@/hooks/useProfileViews";

interface User {
  id: string;
  user_id: string;
  display_name: string;
  age: number;
  photo_urls: string[];
  bio: string;
  distance: number;
  isOnline: boolean;
  public_interests: string[];
  private_interests: string[];
}

interface ProfileModalContentProps {
  user: User;
  onClose: () => void;
}

const ProfileModalContent = ({ user, onClose }: ProfileModalContentProps) => {
  const { handleProfileView } = useProfileViews();
  
  const {
    currentPhotoIndex,
    photos,
    nextPhoto,
    prevPhoto,
    hasMultiplePhotos
  } = usePhotoCarousel(user.photo_urls);

  const {
    handleBuzzz,
    handleMessage,
    handleReport,
    isBuzzing
  } = useProfileActions(user, onClose);

  // Track profile view when modal opens
  useEffect(() => {
    handleProfileView(user.user_id);
    console.log('Profile view tracked for user:', user.user_id);
  }, [user.user_id, handleProfileView]);

  return (
    <div className="relative">
      <ProfilePhotoCarousel
        photos={photos}
        userName={user.display_name}
        userId={user.user_id}
      />

      <ProfileDetails
        displayName={user.display_name}
        age={user.age}
        distance={user.distance}
        bio={user.bio}
        publicInterests={user.public_interests}
      />

      <ProfileActionButtons
        onBuzzz={handleBuzzz}
        onMessage={handleMessage}
        onReport={handleReport}
        isBuzzing={isBuzzing}
      />
    </div>
  );
};

export default ProfileModalContent;
